

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { SubscriptionFormComponent } from './subscription-form/subscription-form.component';
import { SubscriptionComponent } from './subscription.component';
import { SubscriptionRoutes } from './subscription.routing';

export function declaration() {
    return [SubscriptionComponent, SubscriptionFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class SubscriptionModule {
}

@NgModule({
    imports: [SubscriptionModule, SubscriptionRoutes],
    exports: [SubscriptionModule]
})
export class SubscriptionWithRouteModule {
}
